module.exports = __webpack_public_path__ + "static/img/patent-6.0b43a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/patent-6.png
// module id = jmmR
// module chunks = 0